// RESPONSABILIDAD:
// - Renderiza mensajes
// - Gestiona scroll automático
// - Muestra edición / borrado / leído

import React, { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const myNombreLocal = localStorage.getItem("user_nombre") || "";
const myEmailLocal = (localStorage.getItem("user_email") || "").toLowerCase();

export default function ChatWindow({
                                       mensajes = [],
                                       myNombre = myNombreLocal,
                                       myEmail = myEmailLocal,
                                       onEdit,
                                       onDelete,
                                       readByMap = {},
                                   }) {
    const endRef = useRef(null);

    const [editandoId, setEditandoId] = useState(null);
    const [nuevoTexto, setNuevoTexto] = useState("");

    const myEmailLower = useMemo(() => (myEmail || "").toLowerCase(), [myEmail]);
    const myNombreTrim = useMemo(() => (myNombre || "").trim(), [myNombre]);

    useEffect(() => {
        endRef.current?.scrollIntoView();
    }, [mensajes]);

    const esMioFn = (m) => {
        const msgEmail = (m.user_email || m.email || "").toLowerCase().trim();
        const msgUser = (m.usuario || "").trim();

        // 1) Preferido: email
        if (myEmailLower && msgEmail) return msgEmail === myEmailLower;

        // 2) Fallback: nombre/usuario (menos fiable)
        if (myNombreTrim && msgUser) return msgUser === myNombreTrim;

        return false;
    };

    return (
        <div className="flex flex-col h-full w-full">
            <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4 bg-gray-50 dark:bg-gray-950 w-full">
                <AnimatePresence initial={false}>
                    {mensajes.map((m) => {
                        const esMio = esMioFn(m);
                        const editando = editandoId === m.idmensaje;

                        return (
                            <motion.div
                                key={m.idmensaje}
                                className={`flex ${esMio ? "justify-end" : "justify-start"} items-end`}
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                exit={{ opacity: 0, y: 10 }}
                                transition={{ duration: 0.15 }}
                            >
                                {!esMio && (
                                    <div className="mr-2 mb-1 w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-700 flex items-center justify-center text-sm font-semibold text-gray-700 dark:text-gray-200">
                                        {(m.usuario || m.email || "?")[0]?.toUpperCase()}
                                    </div>
                                )}

                                <div
                                    className={`
                    min-w-[150px] max-w-[85%] px-5 py-3 rounded-2xl shadow-sm border
                    ${esMio
                                        ? "bg-blue-600 text-white border-blue-700 rounded-br-md"
                                        : "bg-white text-gray-900 border-gray-200 dark:bg-gray-800 dark:text-gray-100 dark:border-gray-700 rounded-bl-md"}
                  `}
                                >
                                    <div className="flex justify-between items-center text-xs mb-1 opacity-70">
                    <span>
                      {(m.usuario || m.email || "Usuario")} ·{" "}
                        {m.fecha
                            ? new Date(m.fecha).toLocaleTimeString([], {
                                hour: "2-digit",
                                minute: "2-digit",
                            })
                            : ""}
                    </span>

                                        {/* Acciones solo si es mío y hay handlers */}
                                        {esMio && !editando && (onEdit || onDelete) && (
                                            <span className="ml-2 flex gap-2">
                        {onEdit && (
                            <button
                                className="hover:opacity-80"
                                title="Editar"
                                onClick={() => {
                                    setEditandoId(m.idmensaje);
                                    setNuevoTexto(m.contenido || "");
                                }}
                            >
                                ✏️
                            </button>
                        )}
                                                {onDelete && (
                                                    <button
                                                        className="hover:opacity-80"
                                                        title="Eliminar"
                                                        onClick={() => onDelete?.(m.idmensaje)}
                                                    >
                                                        🗑️
                                                    </button>
                                                )}
                      </span>
                                        )}
                                    </div>

                                    {editando ? (
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                const t = (nuevoTexto || "").trim();
                                                if (!t) return;
                                                onEdit?.(m.idmensaje, t);
                                                setEditandoId(null);
                                            }}
                                            className="flex items-center gap-2"
                                        >
                                            <input
                                                type="text"
                                                value={nuevoTexto}
                                                onChange={(e) => setNuevoTexto(e.target.value)}
                                                autoFocus
                                                className="flex-1 rounded-md border px-2 py-1 text-sm bg-white text-black"
                                            />
                                            <button type="submit" title="Guardar">✔️</button>
                                            <button
                                                type="button"
                                                title="Cancelar"
                                                onClick={() => setEditandoId(null)}
                                            >
                                                ✖️
                                            </button>
                                        </form>
                                    ) : (
                                        <div className="whitespace-pre-line text-base md:text-lg">
                                            {m.contenido}
                                        </div>
                                    )}

                                    {Array.isArray(readByMap[m.idmensaje]) &&
                                        readByMap[m.idmensaje].length > 0 && (
                                            <div className="mt-1 text-[10px] opacity-60">
                                                Visto por: {readByMap[m.idmensaje].join(", ")}
                                            </div>
                                        )}
                                </div>
                            </motion.div>
                        );
                    })}
                </AnimatePresence>

                <div ref={endRef} />
            </div>
        </div>
    );
}
